var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9727 37.5962L39.1843 44.3879C38.9493 44.6229 38.631 44.7545 38.2993 44.7545C37.9677 44.7545 37.6493 44.6229 37.416 44.3879L34.1211 41.0879C33.6344 40.5979 33.6344 39.8062 34.1227 39.3179C34.6127 38.8312 35.4027 38.8329 35.8911 39.3195L38.301 41.7345L44.2043 35.8278C44.6927 35.3395 45.4843 35.3395 45.9727 35.8278C46.461 36.3162 46.461 37.1079 45.9727 37.5962ZM54.506 36.8095L53.341 35.6445C52.8093 35.1112 52.5177 34.4012 52.5177 33.6495V31.9828C52.5177 29.5012 50.4977 27.4828 48.0177 27.4828H46.3477C45.5927 27.4828 44.8843 27.1912 44.3543 26.6612L43.1693 25.4778C41.4077 23.7312 38.5543 23.7395 36.806 25.4962L35.6444 26.6612C35.1094 27.1928 34.4011 27.4845 33.6477 27.4845H31.9794C29.5277 27.4862 27.5277 29.4595 27.4827 31.9028C27.4811 31.9295 27.4794 31.9562 27.4794 31.9845V33.6462C27.4794 34.3995 27.1877 35.1078 26.6561 35.6395L25.4761 36.8212C25.4744 36.8262 25.4694 36.8279 25.4661 36.8312C23.7244 38.5945 23.7394 41.4479 25.4944 43.1862L26.6594 44.3545C27.1894 44.8862 27.4827 45.5929 27.4827 46.3462V48.0212C27.4827 50.5012 29.4994 52.5195 31.9794 52.5195H33.6444C34.3994 52.5212 35.1077 52.8129 35.6377 53.3412L36.826 54.5262C37.6727 55.3679 38.796 55.8312 39.991 55.8312H40.011C41.2127 55.8262 42.3393 55.3529 43.1827 54.5045L44.351 53.3379C44.876 52.8145 45.6027 52.5145 46.3443 52.5145H48.021C50.496 52.5145 52.5143 50.4995 52.5193 48.0212V46.3495C52.5193 45.5979 52.811 44.8895 53.3393 44.3579L54.5243 43.1729C56.2743 41.4129 56.2643 38.5579 54.506 36.8095Z",
    fill: "#0EB869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.0f4c5bc25b5a1df1baff1eaacc89a71c.svg";
export { ForwardRef as ReactComponent };